import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { CtaWhatsApp } from "../components/Cta";
import { Reveal } from "../components/motion";
import { ARTICLES } from "../data/articles";

export default function Blog() {
  return (
    <>
      <Seo
        title="Conseils — Guides pour professionnels"
        description="Guides pratiques Noveocard : obtenir plus d'avis Google, transformer vos clients en abonnés Instagram, carte de visite digitale pour entreprises."
        path="/conseils"
      />
      <PageHero
        dark
        eyebrow="Conseils"
        titleLines={["Des guides concrets,", "pour pros concrets."]}
        description="Avis Google, réseaux sociaux, image professionnelle : des méthodes simples pour que chaque passage en boutique, en salon ou sur un chantier devienne une relation durable."
      />

      <section className="bg-brume py-16 sm:py-24">
        <div className="container-nv grid gap-6 md:grid-cols-3">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.08} className="h-full">
              <Link
                to={`/conseils/${a.slug}`}
                data-testid={`blog-card-${a.slug}`}
                className="group flex h-full flex-col rounded-3xl border border-nuit-900/10 bg-white p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-24px_rgba(7,26,45,0.35)]"
              >
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-electric/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-electric">
                    {a.category}
                  </span>
                  <span className="flex items-center gap-1.5 text-xs text-steel">
                    <Clock className="h-3.5 w-3.5" /> {a.readTime}
                  </span>
                </div>
                <h2 className="mt-5 font-display text-xl font-bold leading-snug text-nuit-900">
                  {a.title}
                </h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-steel">{a.intro}</p>
                <span className="mt-6 inline-flex items-center gap-2 font-display text-sm font-semibold text-electric">
                  Lire le guide
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="container-nv mt-14 flex flex-col items-center gap-3 text-center">
          <p className="max-w-lg font-display text-2xl font-bold text-nuit-900">
            Chaque guide mène au même endroit : un seul geste.
          </p>
          <p className="max-w-md text-steel">
            La carte digitale Noveocard met en pratique tout ce que vous lirez ici.
          </p>
          <CtaWhatsApp showResponseTime testid="blog-cta-whatsapp" />
        </div>
      </section>
    </>
  );
}
